import React from "react";
import { LeagueContext } from "../context/LeagueContext";

export function useLeague() {
  return React.useContext(LeagueContext);
}
